import React from "react";
import {
  Nav,
  NavLink,
  NavbarContainer,
  Span,
  NavLogo,
  NavItems,
  GitHubButton,
  PrimaryButton,
  Toggle,
  ToggleThumb,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink,
} from "./NavbarStyledComponent";

import { FaBars } from "react-icons/fa";
import { Bio } from "../../data/constants";
import { useTheme } from "styled-components";
import { useLocation } from "react-router-dom";

const Navbar = ({ darkMode, setDarkMode }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme();
  const location = useLocation();

  const handleToggleTheme = () => {
    setDarkMode(!darkMode);
  };

  // Render Navbar based on the route
  const renderNavLinks = () => {
    if (location.pathname === "/products") {
      // For the "/products" route
      return (
        <NavItems>
          <NavLink href="/">Home</NavLink>
        </NavItems>
      );
    } else {
      // Default Navbar
      return (
        <NavItems>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#achievement">Achievement</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#products">Study-Material</NavLink>
        </NavItems>
      );
    }
  };

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to="/">
          <a
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <Span>Srinjoy Das</Span>
          </a>
        </NavLogo>
        <MobileIcon>
          <FaBars
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          />
        </MobileIcon>

        {/* Render Nav Links based on the route */}
        {renderNavLinks()}

        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank">
            Github
          </GitHubButton>
          <PrimaryButton href={Bio.call} target="_blank">
            Schedule Call
          </PrimaryButton>
          {/* Slide Toggle Button */}
          <Toggle
            active={darkMode}
            onClick={handleToggleTheme}
            aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            <ToggleThumb active={darkMode} />
          </Toggle>
        </ButtonContainer>

        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            {/* Mobile-specific links */}
            {location.pathname === "/products" ? (
              <MobileLink
                href="/"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                Home
              </MobileLink>
            ) : (
              <>
                <MobileLink
                  href="#about"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  About
                </MobileLink>
                <MobileLink
                  href="#skills"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  Skills
                </MobileLink>
                <MobileLink
                  href="#experience"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  Experience
                </MobileLink>
                <MobileLink
                  href="#projects"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  Projects
                </MobileLink>
                <MobileLink
                  href="#achievement"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  Achievement
                </MobileLink>
                <MobileLink
                  href="#products"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  Study-Material
                </MobileLink>
              </>
            )}
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
